// Тонкие линейные иконки, 16×16, stroke=1.5
export const Icon = ({ name, size = 16, className = "" }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
  };
  const paths = {
    users: <><circle cx="6" cy="6" r="2.5"/><path d="M2 13c0-2.2 1.8-3.5 4-3.5s4 1.3 4 3.5"/><path d="M10.5 6.5a2 2 0 1 0 0-3"/><path d="M11 9.5c2 0 3.5 1.3 3.5 3.5"/></>,
    grid: <><rect x="2" y="2" width="5" height="5" rx="0.5"/><rect x="9" y="2" width="5" height="5" rx="0.5"/><rect x="2" y="9" width="5" height="5" rx="0.5"/><rect x="9" y="9" width="5" height="5" rx="0.5"/></>,
    book: <><path d="M3 2.5h7a2 2 0 0 1 2 2v9H5a2 2 0 0 1-2-2v-9z"/><path d="M3 11.5a2 2 0 0 1 2-2h7"/></>,
    calendar: <><rect x="2.5" y="3.5" width="11" height="10" rx="1"/><path d="M2.5 6.5h11M5.5 2v3M10.5 2v3"/></>,
    check: <><path d="M3 8.5l3 3 7-7"/></>,
    wallet: <><rect x="2" y="4" width="12" height="9" rx="1.5"/><path d="M2 7h12M11 10h1.5"/></>,
    doc: <><path d="M4 2h5l3 3v9H4z"/><path d="M9 2v3h3M6 8h4M6 10.5h4"/></>,
    spark: <><path d="M8 2v4M8 10v4M2 8h4M10 8h4M4.5 4.5l1.5 1.5M10 10l1.5 1.5M4.5 11.5l1.5-1.5M10 6l1.5-1.5"/></>,
    tag: <><path d="M2.5 2.5h5l6 6-5 5-6-6z"/><circle cx="5.5" cy="5.5" r="0.8"/></>,
    chat: <><path d="M2.5 4.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7L4 14v-2.5a2 2 0 0 1-1.5-2z"/></>,
    bell: <><path d="M4 11V7a4 4 0 1 1 8 0v4l1 1.5H3z"/><path d="M6.5 13.5a1.5 1.5 0 0 0 3 0"/></>,
    badge: <><rect x="2.5" y="3" width="11" height="10" rx="1.5"/><circle cx="8" cy="7" r="1.5"/><path d="M5.5 11c.6-1 1.5-1.5 2.5-1.5s1.9.5 2.5 1.5"/></>,
    chart: <><path d="M2.5 13.5V3M2.5 13.5H13M5 11V8M8 11V5M11 11V7"/></>,
    gear: <><circle cx="8" cy="8" r="2"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.3 3.3l1.4 1.4M11.3 11.3l1.4 1.4M3.3 12.7l1.4-1.4M11.3 4.7l1.4-1.4"/></>,
    search: <><circle cx="7" cy="7" r="4.5"/><path d="M10.5 10.5L14 14"/></>,
    plus: <><path d="M8 3v10M3 8h10"/></>,
    filter: <><path d="M2 3h12l-4.5 5.5v4.5L6.5 12V8.5z"/></>,
    chevron: <><path d="M6 4l4 4-4 4"/></>,
    "chevron-left": <><path d="M10 4l-4 4 4 4"/></>,
    chevronDown: <><path d="M4 6l4 4 4-4"/></>,
    card: <><rect x="2" y="4" width="12" height="9" rx="1.5"/><path d="M2 7h12"/></>,
    more: <><circle cx="3.5" cy="8" r="1"/><circle cx="8" cy="8" r="1"/><circle cx="12.5" cy="8" r="1"/></>,
    menu: <><path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11"/></>,
    phone: <><path d="M3 3.5a1.5 1.5 0 0 1 1.5-1.5h1L7 5 5.5 6.5a7 7 0 0 0 4 4L11 9l3 1.5v1a1.5 1.5 0 0 1-1.5 1.5A9.5 9.5 0 0 1 3 3.5z"/></>,
    money: <><circle cx="8" cy="8" r="5.5"/><path d="M8 5v6M10 6.5C9.5 5.8 8.8 5.5 8 5.5c-1 0-1.8.5-1.8 1.2 0 .8.8 1 1.8 1.3s1.8.5 1.8 1.3c0 .7-.8 1.2-1.8 1.2-.8 0-1.5-.3-2-1"/></>,
    mail: <><rect x="2" y="3.5" width="12" height="9" rx="1"/><path d="M2.5 4.5l5.5 4 5.5-4"/></>,
    x: <><path d="M4 4l8 8M12 4l-8 8"/></>,
    archive: <><rect x="2" y="3" width="12" height="3" rx="0.5"/><path d="M3 6v7h10V6M6 9h4"/></>,
    download: <><path d="M8 2v8M5 7l3 3 3-3M3 13h10"/></>,
    columns: <><rect x="2.5" y="2.5" width="11" height="11" rx="1"/><path d="M6 2.5v11M10 2.5v11"/></>,
    sort: <><path d="M4 3v10M4 3l-1.5 1.5M4 3l1.5 1.5M12 13V3M12 13l-1.5-1.5M12 13l1.5-1.5"/></>,
    dot: <circle cx="8" cy="8" r="2.5" fill="currentColor" stroke="none"/>,
    eye: <><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"/><circle cx="8" cy="8" r="1.8"/></>,
    "eye-off": <><path d="M2 2l12 12M6.5 4a8 8 0 0 1 1.5-.15c4 0 6.5 4.15 6.5 4.15a13 13 0 0 1-2.2 2.6M9.5 12a8 8 0 0 1-1.5.15c-4 0-6.5-4.15-6.5-4.15a13 13 0 0 1 2.7-3.1"/><path d="M6.5 6.5a2 2 0 0 0 3 3"/></>,
    alert: <><path d="M8 2.5L14.5 13.5h-13z"/><path d="M8 7v3M8 11.5v0.5"/></>,
    moon: <><path d="M13 9.5A5.5 5.5 0 1 1 6.5 3a4.5 4.5 0 0 0 6.5 6.5z"/></>,
    sun: <><circle cx="8" cy="8" r="3"/><path d="M8 1.5v1.5M8 13v1.5M1.5 8H3M13 8h1.5M3.3 3.3l1 1M11.7 11.7l1 1M3.3 12.7l1-1M11.7 4.3l1-1"/></>,
    graduation: <><path d="M1.5 6L8 3l6.5 3L8 9 1.5 6z"/><path d="M4 7.5v3c0 1 1.8 2 4 2s4-1 4-2v-3"/><path d="M14 6v3.5"/></>,
    sparkle: <><path d="M8 2v3M8 11v3M2 8h3M11 8h3M4.5 4.5l1.5 1.5M11.5 11.5l-1.5-1.5M4.5 11.5l1.5-1.5M11.5 4.5l-1.5 1.5"/><circle cx="8" cy="8" r="1.5"/></>,
    message: <><path d="M2.5 4.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7L4 14v-2.5a2 2 0 0 1-1.5-2z"/></>,
    info: <><circle cx="8" cy="8" r="6"/><path d="M8 7v4M8 5v0.5"/></>,
    external: <><path d="M9 2h5v5M14 2L7.5 8.5M12 9v4H3V4h4"/></>,
    "plus-circle": <><circle cx="8" cy="8" r="6"/><path d="M8 5v6M5 8h6"/></>,
    clock: <><circle cx="8" cy="8" r="6"/><path d="M8 5v3.5L10 10"/></>,
    link: <><path d="M7 9.5l-1.5 1.5a2.5 2.5 0 0 1-3.5-3.5l2-2a2.5 2.5 0 0 1 3.5 0"/><path d="M9 6.5l1.5-1.5a2.5 2.5 0 0 1 3.5 3.5l-2 2a2.5 2.5 0 0 1-3.5 0"/></>,
    "link-off": <><path d="M6 8L4.5 9.5a2.5 2.5 0 0 1-3.5-3.5l1-1M10 8l1.5-1.5a2.5 2.5 0 0 1 3.5 3.5l-1 1M2 2l12 12"/></>,
    upload: <><path d="M8 14V6M5 9l3-3 3 3M3 2.5h10"/></>,
    edit: <><path d="M2.5 13.5h11M3 11l8-8 2 2-8 8H3v-2z"/></>,
    trash: <><path d="M2.5 4h11M6 4V2.5h4V4M4 4l.8 9.5h6.4L12 4M6.5 6.5v5M9.5 6.5v5"/></>,
    home: <><path d="M2.5 7L8 2.5 13.5 7v6a1 1 0 0 1-1 1h-3v-4h-3v4h-3a1 1 0 0 1-1-1V7z"/></>,
    baby: <><circle cx="8" cy="5" r="2.5"/><path d="M3.5 13.5c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4M6 5h4M7 5.5c.3.3.7.3 1 .3s.7 0 1-.3"/></>,
    star: <><path d="M8 2l1.85 3.75 4.15.6-3 2.95.7 4.15L8 11.5l-3.7 1.95.7-4.15-3-2.95 4.15-.6z"/></>,
    paperclip: <><path d="M11.5 6.5L6.5 11.5a2 2 0 0 1-3-3L9 3a3 3 0 0 1 4 4L7 13a4 4 0 0 1-6-6"/></>,
  };
  return <svg {...common}>{paths[name] || null}</svg>;
};

export default Icon;
